import { useEffect, useState } from "react";
import { Form, Radio, Checkbox, Space } from "antd";
import { translateDay } from "@/lib/dateTime";
import { getLangList } from '@/lib/i18n';
import ResponsiveTable from '@/components/responsiveTable';
import { AllPeriodType, SelfStudyType } from './types';

type Props = {
  form: any;
  allPeriodArray: AllPeriodType[];
  selfStudyInfo: SelfStudyType;
}

function ModalSelfStudy(props: Props) {
  const { form, allPeriodArray, selfStudyInfo } = props;
  const [studyTimeId, setStudyTimeId] = useState([] as any);
  const { classType, timePeriodIds } = selfStudyInfo;
  const timeObject: any = allPeriodArray?.find((item: AllPeriodType) => item.classType === classType) ?? [];
  const { days = [] } = timeObject;
  const t: any = getLangList("selfStudy");

  useEffect(() => {
    form.setFieldsValue({ studyTimeId: timePeriodIds });
    setStudyTimeId(timePeriodIds);
  }, [form, timePeriodIds]);

  const selfStudyColumns = (renderOption: any) => ([
    { dataIndex: "day", render: (text: string, record: any, index: number) => translateDay(index) },
    {
      title: t.BEFORE_SCHOOL,
      dataIndex: "before",
      render: (text: string, record: any) => renderOption(record, 'BEFORE'),
    },
    {
      title: t.AFTER_SCHOOL,
      dataIndex: "after",
      render: (text: string, record: any) => renderOption(record, 'AFTER'),
    },
  ]);

  const clickCheckbox = (timePeriodId: string) => (e: any) => {
    const { checked } = e.target;
    const tempStudyTimeIdArray = [...form.getFieldValue('studyTimeId')];
    const studyTimeIdArray = checked
      ? [timePeriodId, ...tempStudyTimeIdArray]
      : tempStudyTimeIdArray.filter((item: any) => item !== timePeriodId);

    form.setFieldsValue({ studyTimeId: studyTimeIdArray });
  };

  const clickRadio = (radioGroupIdArray: any) => (e: any) => {
    const { value } = e.target;
    const tempStudyTimeIdArray = [...form.getFieldValue('studyTimeId')];
    const studyTimeIdArray = tempStudyTimeIdArray.filter((item: any) => radioGroupIdArray.indexOf(item) === -1);

    studyTimeIdArray.push(value);
    form.setFieldsValue({ studyTimeId: studyTimeIdArray });
    setStudyTimeId(studyTimeIdArray);
  };

  const renderOption = (record: any, timeKey: string) => {
    const { studyPeriod } = record;
    const timeObjectArray = studyPeriod[timeKey] ?? [];
    const timePeriodArray = timeObjectArray.filter((item: any) => item.timePeriod !== 'x');
    const radioGroupIdArray: any = [];
    let selectedRadio = -1;
    const getOption = timePeriodArray.map((item: any) => {
      const { timePeriodId, timePeriod, checkbox } = item;
      const defaultChecked = studyTimeId.indexOf(timePeriodId) > -1;

      if (checkbox) {
        return (
          <Checkbox
            key={timePeriodId}
            defaultChecked={defaultChecked}
            onChange={clickCheckbox(timePeriodId)}
          >
            {timePeriod}
          </Checkbox>
        );
      } else {
        radioGroupIdArray.push(timePeriodId);
        if (defaultChecked) {
          selectedRadio = timePeriodId;
        }
        return (
          <Radio key={timePeriodId} value={timePeriodId}>
            {timePeriod}
          </Radio>
        );
      }
    });
    const valueParam = selectedRadio !== -1 ? { value: studyTimeId.find((item: any) => item === selectedRadio) } : {};

    return (
      <Radio.Group onChange={clickRadio(radioGroupIdArray)} {...valueParam}>
        <Space direction="vertical" align="start">
          {getOption}
        </Space>
      </Radio.Group>
    );
  };

  return (
    <>
      <Form
        className="admin-form"
        form={form}
        initialValues={{ studyTimeId: [] }}
      >
        <Form.Item name="studyTimeId" style={{ display: 'none' }}>
          <Checkbox.Group />
        </Form.Item>
      </Form >

      <ResponsiveTable
        dataSource={days}
        columns={selfStudyColumns(renderOption)}
      />
    </>
  );
}

export default ModalSelfStudy;